export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/arrow-41c50b825c6056c3f7bcacb64572bec9.svg";